import Grid from "@material-ui/core/Grid";
import Header from "./Header";
import Pricing from "./Pricing";
import VoiceDemo from "./VoiceDemo";
import TextEditor from "./TextEditor";
import { examples } from "./Examples";
import PdfViewer from "./PdfViewer";
import { useDispatch, useSelector } from "react-redux";
import { StateAction, UserInterface } from "./state/actions/actions";
import { StateInterface } from "./state/reducer/store";
import React, { Dispatch, useEffect, useRef } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import StarsIcon from '@material-ui/icons/Stars';
import Generator from "./Generator";
import TransitionsModal from "./TransitionModal";
import AOS from 'aos';
import "aos/dist/aos.css"
import { StyledFirebaseAuth } from "react-firebaseui";
import firebase from "../assets/firebase";
import FrequentlyAskedQuestions from "./FrequentlyAskedQuestions";

export default function HomePage() {
  const previewPdf = useSelector((state: StateInterface) => state.pdfPreview);
  const loginModal = useSelector((state: StateInterface) => state.loginModal);
  const textLength = useSelector((state: StateInterface) => state.textEditorState);
  const User = useSelector((state: StateInterface) => state.user)
  const config = useSelector((state: StateInterface) => state.config)
  const dispatch: Dispatch<StateAction> = useDispatch();


  // Configure FirebaseUI.
  const uiConfig = {
    // Popup signin flow rather than redirect flow.
    signInFlow: "popup",
    // We will display Google and Facebook as auth providers.
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
      // firebase.auth.GithubAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
      // 'microsoft.com',
      // 'apple.com',
      // 'yahoo.com'
    ],
    callbacks: {
      // Avoid redirects after sign-in.
      signInSuccessWithAuthResult: () => {
        dispatch({ type: 'SET_LOGIN_MODAL', payload: false })
        return false
      },
    },
  };

  const availableVoicesRef = useRef(null)
  const audioGeneratorRef = useRef(null)
  const pricingRef = useRef(null)
  const faqRef = useRef(null)

  const refMap = {
    availableVoicesRef, audioGeneratorRef, pricingRef, faqRef
  }

  const scrollToRef = (refName: string) => {
    (((refMap as any)[refName]).current as HTMLElement).scrollIntoView({
      behavior: "smooth",
      block: 'start'
    })
  }

  useEffect(() => {
    const unregisterAuthObserver = firebase
      .auth()
      .onAuthStateChanged(async (user) => {
        try {
          const call = await firebase.firestore().collection('users').doc(user?.uid).get()
          const additionalData = call.data()
          if (!additionalData) {
            dispatch({
              type: "SET_USER",
              payload: user ? user?.toJSON() : null,
            });
          } else {
            const next: UserInterface = {}
            next.email = additionalData.email
            next.emailVerified = additionalData.emailVerified
            next.freeVoiceQuota = additionalData.freeVoiceQuota
            next.phoneNumber = additionalData.phoneNumber
            next.premiumVoiceQuota = additionalData.premiumVoiceQuota
            next.uid = additionalData.uid
            next.displayName = user?.displayName || 'placeholder'
            dispatch({
              type: "SET_USER",
              payload: user ? next : null,

            });
          }
        } catch (e) {
          console.log(e)
          dispatch({
            type: "SET_USER",
            payload: user ? user?.toJSON() : null,
          });
        }
      });
    AOS.init({ duration: 1000 })
    return () => unregisterAuthObserver(); // Make sure we un-register Firebase observers when the component unmounts.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setLoginModal = () =>
    dispatch({ type: "SET_LOGIN_MODAL", payload: false });
  return (
    <div style={{ overflowX: 'hidden' }}>
      <TransitionsModal modalState={loginModal} setModalState={setLoginModal} >
        <Box>
          <Box >
            {User && <Typography
              variant="h5"
              style={{
                fontWeight: "bold",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {config.textByLanguage.welcome} {firebase.auth()?.currentUser?.displayName || ""}! {config.textByLanguage.signedIn}!
            </Typography>
            }

            {!User && <Typography
              variant="h5"
              style={{
                fontWeight: "bold",
                display: "flex",
                justifyContent: "center",
                marginBottom: 24
              }}
            >
              {config.textByLanguage.pleaseSignIn}!
            </Typography>
            }
            {!User && <StyledFirebaseAuth
              uiConfig={uiConfig}
              firebaseAuth={firebase.auth()}
            />}
          </Box>

        </Box>
        <Box style={{ display: "flex", justifyContent: "space-around" }}>
          {User && <Button
            color="secondary"
            variant="outlined"
            style={{ width: 100, marginTop: 24 }}
            onClick={() => {
              firebase.auth().signOut()
              dispatch({ type: 'SET_USER', payload: null })
              dispatch({ type: "SET_LOGIN_MODAL", payload: false })
            }}
          >
            {config.textByLanguage.signOut}
          </Button>}
          <Button
            color="primary"
            variant="contained"
            style={{ width: 100, marginTop: 24 }}
            onClick={setLoginModal}
          >
            {config.textByLanguage.ok}
          </Button>
        </Box>
      </TransitionsModal>
      <Grid container>
        <Header scrollToRef={scrollToRef} />
      </Grid>


      <div ref={audioGeneratorRef}>
        <Grid item xs={12} >
          <Generator />
        </Grid>
      </div>

      <Grid item xs={12}>

        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center", flexDirection: 'column', alignItems: 'center', marginTop: 16, fontSize: 16 }}
        >
          {User?.freeVoiceQuota && User?.premiumVoiceQuota && < div > {config.textByLanguage.freeCharactersLeft}: <b>{User?.freeVoiceQuota}</b>  | <StarsIcon /> {config.textByLanguage.neuralVoiceCharactersLeft}: <b>{User?.premiumVoiceQuota}</b></div>}
          <div style={{ marginTop: 8 }}>{config.textByLanguage.currentTextLength}: <b>{textLength.getCurrentContent().getPlainText('\u0001').length}</b></div>
        </Grid>

        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center", marginTop: -16 }}
        >
          {previewPdf && <PdfViewer />}

          <TextEditor />
        </Grid>
      </Grid>

      <Grid item xs={12} data-aos="fade-left">
        <VoiceDemo data={examples} />
      </Grid>
      <div ref={pricingRef}>
        <Grid item xs={12} data-aos="fade-right">
          <Pricing />
        </Grid>
      </div>
      <div ref={faqRef}>
        <Grid item xs={12} data-aos="flip-up">
          <FrequentlyAskedQuestions />
        </Grid>
      </div>
    </div>
  );
}
